// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"jTg62":[function(require,module,exports) {
require("4d6f43a1814265fa").register(require("5a0c3ec5bac110f5").getBundleURL("3S33P"), JSON.parse('["3S33P","index.9aacd2e7.js","6wzhE","arbitrum-logo.85a4dbfa.svg","hEvu7","avalanche-logo.ad53a0d0.svg","jkOUd","base-logo.5063e713.png","ihwNp","bnb-logo.64b3c4a0.png","gPyOu","celo-logo.54749d8f.jpg","22eAz","ethereum-logo.ea1b47f0.png","5xx3P","fundora_logo.fed45bad.svg","f0xYd","gnosis-chain-logo.46d76e1d.png","phgH0","logo_orange.b499c218.svg","liQow","optimism-logo.8edbc945.png","8BHcF","polygon-logo.a2b643a2.png","8WETf","redbelly-logo.15200331.png","jW8za","sepolia-logo.decdb70e.png","lP86h","tcs.4d10bcfa.png","jmFWl","xdc-logo.0af9b203.png","cpr2l","unknownToken.4d5ba60a.svg","bLiWJ","native.33c62371.js","hnfDj","secp256k1.f9fef981.js","9IPkY","html2canvas.0cb580c6.js","hQ3CA","purify.c95cf3b4.js","7sZ1Z","index.es.a5efb94c.js","7KPWp","inter.f67fa418.js","1zoCg","native.2c6acbe8.js","dXSk1","native.c5b32167.js","aJKHU","core.b1b82082.js","5Ax6n","secp256k1.7cf480da.js","hbXTc","secp256k1.9b14582b.js","7Yi4X","features.22890551.js","fu1Um","basic.a4b2fec0.js","fjZru","basic.2f8164b8.js","308ay","PhArrowCircleDown.eeb20099.js","36bOH","PhArrowCircleDown.b9c9f608.js","4NRNT","PhArrowClockwise.56d1ead5.js","ezkbJ","PhArrowDown.3cf263ff.js","be8Wi","PhArrowLeft.24e965a5.js","9I2Z2","PhArrowRight.6ecb8ad0.js","gLkxP","PhArrowSquareOut.7f36e723.js","5vNIm","PhArrowsDownUp.8da49862.js","dU3Kv","PhArrowsLeftRight.3a1e0cc8.js","67rx6","PhArrowUp.29961fdb.js","4jrL2","PhArrowUpRight.926f773c.js","jIALR","PhArrowsClockwise.5bb613c4.js","kwg16","PhBank.d342bab1.js","9Hv6B","PhBrowser.d6cd007c.js","c2gWU","PhCaretDown.52c5db03.js","aL6lR","PhCaretLeft.83ad52e9.js","6fA2i","PhCaretRight.6404ec76.js","iGebo","PhCaretUp.be239dcf.js","fNrvV","PhCheck.de3f78fa.js","iXX3j","PhCircleHalf.869085ec.js","3OGrc","PhClock.bfe1d7cf.js","3agUw","PhCompass.89519edf.js","jjAXX","PhCopy.ac5e197f.js","hP5EL","PhCreditCard.6043e311.js","1Y5x7","PhCurrencyDollar.396cc13b.js","bsrgI","PhDesktop.8108c0eb.js","9qk31","PhDeviceMobile.05cb9bcb.js","9jtS9","PhDotsThree.550a0a67.js","7OPtM","PhVault.85ccbb02.js","g2pbl","PhEnvelope.6b418fa4.js","fUpFR","PhFunnelSimple.acba696e.js","jIVjP","PhGlobe.d87334de.js","l0pAd","PhIdentificationCard.30efc242.js","8C0wI","PhImage.4f2b3a9e.js","1l4uI","PhInfo.397f2399.js","MurND","PhLightbulb.22554c16.js","HcCah","PhMagnifyingGlass.e2c6c4e7.js","e9FIk","PhPaperPlaneRight.82982a02.js","2w1X4","PhPlus.e33b7d63.js","lh12r","PhPower.64574217.js","i5EJK","PhPuzzlePiece.be1b75a8.js","9d6QM","PhQrCode.de61093d.js","jbg6D","PhQuestion.717725bd.js","b9kf4","PhQuestionMark.7a3c7408.js","hV7wc","PhSealCheck.de655ff3.js","xdW8X","PhSignOut.9594ed37.js","jUdwq","PhSpinner.37579f26.js","k0IOc","PhTrash.77cea34d.js","1wfEH","PhUser.c1b75474.js","9J2Vd","PhWarning.ab628ca8.js","5mKEG","PhWarningCircle.8c8d4e86.js","Bypej","PhX.0247b0ad.js","920be","w3m-modal.51ca7da4.js","3FPoq","esm.77572f7a.js","RuyX7","TurnstileWrapper-20sam7uS.e905515e.js","WCnrH","HCaptchaWrapper-CUi9LJsp.fb806c25.js","4iZTO","AccountNotFoundScreen-dpvlPdBk.80de5ac7.js","9CZOn","AccountNotFoundScreen-dpvlPdBk.8af1e473.js","5roWq","AccountNotFoundScreen-dpvlPdBk.c43086c7.js","j2kcs","AddFundsSelectionScreen-D252cdfE.fabbaa1f.js","8NTOi","AffirmativeConsentScreen-CNKhHlgd.479ea803.js","ayuPR","AllowlistRejectionScreen-Dxn2QBch.e76a9458.js","9zZrT","AuthenticateWithWalletScreen-XZW4H6Rp.9e045ee4.js","jl4y0","AuthenticateWithWalletScreen-XZW4H6Rp.d68cdf83.js","9CPhr","AuthenticateWithWalletScreen-XZW4H6Rp.b275f2ad.js","XPkun","AuthenticateWithWalletScreen-XZW4H6Rp.b5ff9893.js","fSNBW","AwaitingEvmToSolBridgingScreen-kxYkefvS.36d5fb3d.js","3TXFK","LinkPasskeyScreen-BjrBgk8F.4678dc31.js","fAjO5","AwaitingEvmToSolBridgingScreen-kxYkefvS.fbd5ffbb.js","2vX7k","AwaitingExternalEthereumTransferScreen-CRXTmg6K.73e885a6.js","katpj","AwaitingPasswordlessCodeScreen-Y39Smn5S.cbedeca7.js","erz9A","AwaitingSolToEvmBridgingScreen-m93Tmzeb.26381437.js","gguoU","CaptchaScreen-CjA52GUM.03b36da0.js","02WvF","CoinbaseOnrampStatusScreen-MwBZBEO8.07a6c7a1.js","1ixI9","ConnectLedgerScreen-Cbl7rv9-.91630cc9.js","jY7Jf","ConnectOnlyLandingScreen-DRjLarbZ.61c414bb.js","g7Eip","ConnectOnlyStatusScreen-HQr2eWJ8.d8b943f6.js","lrf3p","ConnectionStatusScreen-CkSP8_A8.e328ce3d.js","5case","ConnectOrCreateScreen-DRvyMrwl.a1f478f5.js","9U7Nz","ConnectOrCreateScreen-DRvyMrwl.db73d90c.js","goCyX","ConnectOrCreateScreen-DRvyMrwl.665d6502.js","hjG5F","CrossAppAuthScreen-CjEnrdrJ.b12da0d9.js","7XrmE","DelegatedActionsConsentScreen-CgjAuH1X.a5ec3756.js","8sr5U","DelegatedActionsRevokeScreen-Ddfj8i91.4f0a8297.js","lsFQo","DepositAddressScreen-DIaAeDcJ.458a5ecd.js","754Pv","DepositAddressScreen-DIaAeDcJ.968ce26a.js","4xFUD","DepositAddressV3Screen-CrX8jlrq.00994420.js","bokp1","EmbeddedWalletConnectingScreen-DTxYtwkh.e5d64eb8.js","3IE0k","EmbeddedWalletCreatedScreen-njjn_fWc.0d1a9fb8.js","h22la","EmbeddedWalletKeyExportScreen-CkF-zPTJ.68def566.js","lKVbk","EmbeddedWalletOnAccountCreateScreen-DVnOfOJg.48d32aef.js","IN0cz","RecoveryPasswordCreateScreen-BLH8kpZr.f033c377.js","dZpDB","RecoveryPasswordCreateScreen-BLH8kpZr.272868a7.js","aOxne","EmbeddedWalletPasswordUpdateScreen-Ce4369UE.a98be19b.js","bUmjV","EmbeddedWalletPasswordUpdateSplashScreen-B9SS2EuP.bf8dac05.js","dw3mY","ErrorScreen-CZXyXJwt.80fd2c1c.js","kCmQS","FarcasterConnectStatusScreen-C9sUwPj2.50096a2d.js","81Zmy","FarcasterSignerStatusScreen-B67IDHNj.e96e9dc0.js","hyNId","FiatOnrampScreen-mHppmT9g.c2915025.js","3e2EU","stripe.esm.7b1a1437.js","ecqf0","FundSolWalletWithExternalSolanaWallet-DAgCcGSZ.850e920c.js","gCOky","FundWithBankDepositScreen-CPTWNJlt.ec9d9743.js","1BJua","FundingEditAmountScreen-Sl84OThy.15459940.js","10UeN","FundingMethodSelectionScreen-C7QABfvW.3dec1107.js","6eVqA","InAppBrowserLoginNotPossible-92qfsBpt.aa3d9ef6.js","fxjk8","InstallWalletScreen-Be7abwcn.c5b6ae4c.js","9oHhn","LandingScreen-DRUbwL_z.f8a94750.js","9pCOF","LinkConflictScreen-BIU8ewTv.e1f8ffd2.js","3LcmI","LinkEmailScreen-DBYu47Ce.b0defa04.js","4Qwb4","LinkPhoneScreen-CxzCokXL.b0d7c393.js","1D2qd","LoginFailedScreen-BogLDpQD.2e3aa1cc.js","gd2OQ","ManualTransferScreen-D_NY_W-D.8c09855d.js","9phKU","MfaAuthEnrollmentFlowScreen-aQyc42kT.df8513ff.js","f6UXw","MfaAuthEnrollmentFlowScreen-aQyc42kT.712a436c.js","bzNxD","MfaAuthVerifyFlowScreen-Caf1mG_p.814efab1.js","lWhBG","MfaEnrollmentFlowScreen-CsCKhXOZ.93b72477.js","6Y9QJ","MoonpayStatusScreen-C_ioqmOe.d20811ff.js","8Y5L9","OAuthStatusScreen-CippSqIJ.ac20d72e.js","bSPGw","PasskeySelectSignupOrLogin-Bz4eA1kT.958be15e.js","fuYU8","PasskeyStatusScreen-CPNqvDoG.0984a446.js","jAWpU","PasswordRecoveryScreen-BBadAC-E.8b1de476.js","jzJgR","RecoveryOAuthStatusScreen-x9acanvl.9157c77a.js","94BAQ","RecoverySelectionScreen-B4zO4H6R.4009d1b3.js","kiD9X","index-DEvxmE29.3f616d98.js","9b7px","index-DEvxmE29.df0dad97.js","kaR3Y","SetAutomaticRecoveryScreen-GtEwf97v.3aab847a.js","9yp4I","SignRequestScreen-Chf6Z75H.c1b6e8e3.js","6xGTf","StandardSignAndSendTransactionScreen-BlF4_0ms.43d972fb.js","e4UL7","TelegramAuthScreen-BG263Fwa.1b304d85.js","ejdVj","TransferFromWalletScreen-FPypY7tU.4f304a0e.js","l8Rvo","UpdateEmailScreen-D_Zhi8bE.bb74ea4d.js","iA6bi","UpdatePhoneScreen-XtZryXw-.9cd85b85.js","4BQjO","UserLimitReachedScreen-cTdLG4Aq.5ef7deda.js","7RpYq","WalletInterstitialScreen-Bb1Dv0ks.dd4b3f2a.js","aTfZ5","MfaVerifyFlowScreen-CH_lq1t9.09027670.js","bWbwv","delete.08ff6362.svg","dEP8T","excel-icon.5a8f7efd.svg","fcOWI","word-icon.fc31758c.svg","fB06n","qr-scanner-worker.min.671e1e34.js","i2U3O","browser.3010fc8d.js","9kNLV","ccip.f559c16f.js","dzt3u","p256.5cfc969b.js","dAtnF","es2015.a80ced99.js","lDzxv","safe_instructions.07abc7d5.png","jgxzr","file-icon.608912cf.svg","6zW9K","open-details.e0167b49.svg","4HcLP","rocifi_logo.5581df76.svg","bGnBC","spectral_logo.f2743ec5.jpg","dT5j0","Web3 Accounting.0e9112d9.png","9srrx","check-icon.43bffbe0.svg","kYSqn","index.34619b5b.css"]'));

},{"4d6f43a1814265fa":"2zFYR","5a0c3ec5bac110f5":"kcmyD"}],"2zFYR":[function(require,module,exports) {
"use strict";
var mapping = new Map();
function register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function resolve(id) {
    var resolved = mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"kcmyD":[function(require,module,exports) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return "/";
}
function getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}]},["jTg62"], null, "parcelRequire07f2")

//# sourceMappingURL=index.runtime.22c0f1aa.js.map
